// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.

export function toInt(input: string | null, fallback: number): number;
export function toInt(input: string | null, fallback: '-'): number | '-';
export function toInt(input: string | null, fallback: string): number | string;

export function toInt(
  input: string | null,
  fallback: number | string = 0
): number | string {
  if (input === null || input === undefined || input === '') {
    return fallback;
  }
  const n = Number(input);
  return Number.isInteger(n) ? n : fallback;
}

export function convNum(input: any | null, fallback = 0): number {
  if (input === null || input === undefined || input === '') {
    return fallback;
  }
  const a = String(input).split('.');
  const integerPart = a[0] ?? '0';
  const decimalPart = a[1] ? a[1] : '0';
  const milli = (decimalPart + '000').slice(0, 3);
  const concatenated = `${integerPart}${milli}`;
  const n = parseInt(concatenated, 10);
  return Number.isFinite(n) ? n : fallback;
}

export function parseIntCsv(input: string | null): number[] {
  if (!input) {
    return [];
  }
  return input
    .split(',')
    .map(s => s.trim())
    .filter(s => s !== '')
    .map(Number)
    .filter(Number.isInteger);
}

export const NumberUtil = {
  toInt,
  convNum,
  parseIntCsv,
} as const;
